import * as React from 'react';

const styles = require('./styles.scss');

export interface ServiceProps {
    type: 'indoor' | 'outdoor';
    capacity: number;
}

interface ServicesProps {
    ceremonies: ServiceProps[];
    receptions: ServiceProps[];
    rds: ServiceProps[];
    onClickInquire?: () => void;
}

export default class Services extends React.Component<ServicesProps> {
    constructor(props: ServicesProps) {
        super(props);
        this.onClickInquire = this.onClickInquire.bind(this);
    }

    renderAvailableRow(typesAvailable: ('indoor' | 'outdoor')[]) {
        if (typesAvailable.length > 1) {
            return <li>Indoor / Outdoor available</li>;
        } else if (typesAvailable.indexOf('indoor') > -1) {
            return <li>Indoor only</li>;
        } else if (typesAvailable.indexOf('outdoor') > -1) {
            return <li>Outdoor only</li>;
        }
        return null;
    }

    renderCapacityRow(type: 'indoor' | 'outdoor', capacity: number) {
        let typeStr;
        switch (type) {
            case 'indoor':
                typeStr = 'Indoor';
                break;
            case 'outdoor':
                typeStr = 'Outdoor';
                break;
            default:
                break;
        }

        if (!typeStr) {
            return null;
        }

        return (
            <li>
                Max {typeStr} capacity: {capacity}
            </li>
        );
    }

    onClickInquire(e: React.SyntheticEvent<HTMLAnchorElement>) {
        e.preventDefault();
        if (!!this.props.onClickInquire) {
            this.props.onClickInquire();
        }
    }

    renderServicesColumn(serviceProps: ServiceProps[], renderInquireLink?: boolean) {
        const typesAvailable = serviceProps
            .map((item) => item.type)
            .filter((elem, pos, arr) => {
                return arr.indexOf(elem) === pos;
            });
        const maxIndoorCapacity = serviceProps.reduce((accum, curval) => {
            if (curval.type === 'indoor') {
                return Math.max(accum, curval.capacity);
            }
            return accum;
        }, 0);
        const maxOutdoorCapacity = serviceProps.reduce((accum, curval) => {
            if (curval.type === 'outdoor') {
                return Math.max(accum, curval.capacity);
            }
            return accum;
        }, 0);

        return (
            <div className='Services--rows'>
                <ul>
                    {this.renderAvailableRow(typesAvailable)}
                    {maxIndoorCapacity > 0 && this.renderCapacityRow('indoor', maxIndoorCapacity)}
                    {maxOutdoorCapacity > 0 && this.renderCapacityRow('outdoor', maxOutdoorCapacity)}
                    {renderInquireLink && !!this.props.onClickInquire && (
                        <a href='#' onClick={this.onClickInquire}>
                            Inquire
                        </a>
                    )}
                </ul>
            </div>
        );
    }

    render() {
        const { ceremonies, receptions, rds } = this.props;

        return (
            <div className='Services'>
                {ceremonies.length > 0 && (
                    <div className='Services--column'>
                        <div className='Services--column-header'>Ceremony</div>
                        {this.renderServicesColumn(ceremonies)}
                    </div>
                )}
                {receptions.length > 0 && (
                    <div className='Services--column'>
                        <div className='Services--column-header'>Reception</div>
                        {this.renderServicesColumn(receptions)}
                    </div>
                )}
                {rds.length > 0 && (
                    <div className='Services--column'>
                        <div className='Services--column-header'>Rehearsal Dinner or Bridal Shower</div>
                        {this.renderServicesColumn(rds, true)}
                    </div>
                )}
            </div>
        );
    }
}
